/* eslint-disable no-console */

import { siteURL } from "@/constants/base_url.js";
import { register } from "register-service-worker";
import router from "@/router";

const HOME_ROUTE_PATH = "/cabine/home";
// O totem fica dias sem navegar de verdade (SPA), e o navegador só procura SW
// novo em navegação. Sem checagem periódica, um deploy — ou uma instalação que
// o SW recusou por pegar o CDN ainda propagando — só chegaria no próximo boot.
const INTERVALO_CHECAGEM_UPDATE_MS = 30 * 60 * 1000;

// Aplica um novo bundle (deploy) recarregando a página — mas SÓ com o totem
// ocioso na Home, nunca no meio de uma compra. Fora da Home, adia até voltar.
let novoBundleAgendado = false;
function aplicarNovoBundleQuandoOcioso() {
  if (novoBundleAgendado) return;
  novoBundleAgendado = true;
  const naHome = () =>
    router.currentRoute && router.currentRoute.path === HOME_ROUTE_PATH;
  if (naHome()) {
    window.location.reload();
    return;
  }
  router.afterEach((to) => {
    if (to.path === HOME_ROUTE_PATH) window.location.reload();
  });
}

if (process.env.NODE_ENV === "production") {
  // Recarrega só quando o SW novo já controla a página (controllerchange), e
  // não no "updated" (SW ainda no estado installed): assim o reload é servido
  // pelo SW novo, com o index.html e os assets do mesmo build. Só vale pra
  // atualização — na primeira instalação não havia controlador e não há o que
  // recarregar.
  if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.addEventListener(
      "controllerchange",
      aplicarNovoBundleQuandoOcioso
    );
  }

  register(`${siteURL}service-worker.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB"
      );
    },
    registered(registration) {
      console.log("Service worker has been registered.");
      setInterval(() => {
        registration.update().catch(() => {
          // sem rede ou SW recusado: tenta de novo no próximo intervalo
        });
      }, INTERVALO_CHECAGEM_UPDATE_MS);
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    updated() {
      console.log("New content is available; updating when idle.");
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    },
  });
}
